import { AngularEditorConfig } from '@kolkov/angular-editor';

export const editorConfig: AngularEditorConfig = {
	editable: true,
	spellcheck: true,
	minHeight: '10em',
	maxHeight: 'none',
	translate: 'yes',
	enableToolbar: true,
	showToolbar: true,
	defaultParagraphSeparator: 'p',
	outline: true,
	sanitize: false,
	toolbarPosition: 'top',
	toolbarHiddenButtons: [
		['insertImage', 'insertVideo'],
		['fontSize', 'fontColor', 'fontName', 'textColor', 'backgroundColor'],
		['subscript', 'superscript']
	]
};
